import {
  postCommonCompanyConfigGetCompanyConfig,
  postCommonCompanyConfigGetDataNumShow,
  postCommonCompanyConfigSaveProcessConfig,
} from '@/services/yizhe-web/gongsipeizhi';
import { useCallback, useEffect, useState } from 'react';

export default () => {
  const [state, setState] = useState<{
    dataNumShowList: string[];
    processConfig: NonNullable<API.GetProcessConfigResult['data']>['process_config'];
    companyConfig: NonNullable<API.GetCompanyConfigResult['data']>;
    configLastUpdated: number;
    loading: boolean;
    error: any;
  }>({
    dataNumShowList: [],
    processConfig: {},
    companyConfig: {},
    configLastUpdated: 0,
    loading: false,
    error: null,
  });
  const getNumDataShow = useCallback(async () => {
    setState((s) => ({ ...s, loading: true, error: undefined }));
    try {
      // 获取是否展示数量
      const { code, data } = await postCommonCompanyConfigGetDataNumShow({});
      if (code === '200') {
        setState((s) => ({ ...s, dataNumShowList: data?.data_num_show || [] }));
      }
    } catch (e) {
      setState((s) => ({ ...s, error: e, loading: false }));
    }
  }, []);
  type ListItem = NonNullable<API.GetUserListByFilterResult['data']>['list'];
  // 过滤工厂、工艺厂、供应商列表
  const filterOptionList = (
    ids: number[] | undefined = [],
    list: ListItem[] = [],
    key: 'factory_id' | 'supply_id',
  ): any[] => {
    const newList = list.filter((item: any) => {
      const isShow = item.show_status === 1;
      const isEchoIdShow = ids?.includes(item[key]);
      return isShow || isEchoIdShow;
    });

    return newList;
  };
  //   获取全局配置
  const getProcessConfig = async () => {
    try {
      setState((s) => ({ ...s }));
      const { code, data } = await postCommonCompanyConfigGetCompanyConfig({
        config_types: [1, 2, 3, 4, 5, 6, 7, 8],
      });
      if (code === '200') {
        const config = data || {};

        // 更新状态
        setState((s) => ({
          ...s,
          processConfig: config,
        }));
        console.log('config', config);

        return;
      }
    } catch (e) {
      setState((s) => ({ ...s, error: e }));
    }
  };
  //   获取公司配置
  const getCompanyConfig = async (params?: any = {}) => {
    try {
      // 获取是否展示数量
      const { code, data }: any = await postCommonCompanyConfigGetCompanyConfig({
        config_type: 4,
        ...params,
      });
      if (code === '200') {
        setState((s) => ({ ...s, companyConfig: data || {} }));
        return;
      }
    } catch (e) {
      setState((s) => ({ ...s, error: e, loading: false }));
    }
  };
  // 更新配置
  const updateProcessConfig = async (newConfig) => {
    try {
      const { code } = await postCommonCompanyConfigSaveProcessConfig({
        process_config: newConfig,
      });

      if (code === '200') {
        // 保存成功后立即更新本地状态和缓存
        // await getProcessConfig(true);
        return true;
      }
      return false;
    } catch (e) {
      setState((s) => ({ ...s, error: e }));
      return false;
    }
  };
  useEffect(() => {
    // getNumDataShow();
  }, []);

  return {
    ...state,
    getNumDataShow,
    filterOptionList,
    getProcessConfig,
    getCompanyConfig,
    updateProcessConfig,
  };
};
